import { FC } from 'react';
import { Typography } from '@flash-tecnologia/hros-web-ui-v2';

interface BaseLayoutProps {
  title: string;
  subTitle?: string;
  optional?: boolean;
}

export const TitleAndSubtitle: FC<BaseLayoutProps> = ({ title, subTitle }) => {
  return (
    <div>
      <Typography
        variant="headline8"
        style={{ fontWeight: '700', color: '#53464F' }}
      >
        {title}
      </Typography>
      <Typography
        variant="headline9"
        style={{ fontWeight: '400', color: '#83727D', marginTop: '5px' }}
      >
        {subTitle}
      </Typography>
    </div>
  );
};
